<template>
  <div class="wing-layout">
    <div class="main-wrap">
      <div id="main-content">
        <div class="wrapper">
          <div class="table-agile-info">
            <jm-crumbs :crm_id="this.$route.params.id"/>
            <div class="basic-title"><em>材料云盘</em></div>
            <div class="noCycle">
              <div class="noCycle-operation">
                <el-button
                  type="primary"
                  size="small"
                  @click="setCycleChoose(true)">选择</el-button>
                <div
                  class="noCycle-block"
                  v-if="fatherCloudSub.isCycleChoose">
                  <el-button
                    type="primary"
                    size="small"
                    @click="setCycleChoose(false)">取消</el-button>
                  <el-button
                    type="primary"
                    size="small"
                    :disabled="checkList && checkList.length <= 0"
                    @click="batchDownload">批量下载</el-button>
                  <el-checkbox
                    :indeterminate="isIndeterminate"
                    v-model="checkAll"
                    @change="handleCheckAllChange">全选</el-checkbox>
                </div>
              </div>
              <div v-if="countryOfferId.offer_id && countryOfferId.country_id">
                <jm-material-cloud
                  upload-url="/newfib.php/index/apply_file/upload"
                  ref="refAllCheckData"
                  :additional-sub="fatherCloudSub"
                  @component-cloud-data="componentCloudData"
                  @check-list-data="checkListData"
                  :all-check-data="checkList"
                  :upload-data="{
                    crm_id: this.$route.params.id,
                    offer_id: countryOfferId.offer_id,
                  }"
                  :upload-position="{
                    country_id: countryOfferId.country_id,
                    upload_position: '通用云盘',
                    offer_school_id: 0,
                }"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--   &lt;!&ndash;走马灯 预览展示 start&ndash;&gt;
      <img v-show="false" ref="vueimg" v-img:group v-for="item in picFilesUrl" :boxsId="item.boxsId" :resultId="item.filesId" :key="item.filesId" :src="item.filesUrl">
    &lt;!&ndash;走马灯 预览展示 end&ndash;&gt;
    <div class="rotate-area left-rotate" @click="rotateClick(-90)"></div>
    <div class="rotate-area right-rotate" @click="rotateClick(90)"></div>
    <div class="rotate-area save-rotate" @click="saveRotate"></div> -->
  </div>
</template>
<script>
import Vue from 'vue';
import VueImg from '@/plugins/v-img';
import crumbs from '@/components/tool/crumbs';
import tableCheckbox from '@/components/tool/tableCheckbox';
import jmMaterialCloud from '@/components/tool/materialCloud';
import { getBinaryContent } from 'jszip-utils';
import JSZip from 'jszip';
import NProgress from 'nprogress';
import moment from 'moment';

Vue.use(VueImg);

let allChecked = [];
export default {
  data() {
    return {
      loading: false, // Loading
      countryOfferId: {}, // 国家id 和 offer id
      //  inited: false,
      checkAll: false,
      checkList: [],
      isIndeterminate: false, // 全选 checkbox
      fatherCloudSub: {
        isCycleChoose: false,
        isCyCLeChooseMask: false,
      },
      allFiles: {},
    };
  },
  computed: {
  },
  created() {
    this.$nextTick(() => {
      this.getCountryOfferId().then(({ data }) => {
        if (data.country_id === 0 || data.offer_id === 0) {
          let str = '择校订单';
          if (data.country_id === 83 || data.country_id === 485) {
            str = '文案流程中的择校信息';
          }
          this.$message.error(`请先完成${str}，才能使用材料云盘！`);
        } else {
          this.countryOfferId = data;
        }
      });
    });
  },
  components: {
    'jm-crumbs': crumbs, // 面包屑
    'jm-tableCheckBox': tableCheckbox, // 设置材料
    jmMaterialCloud, // 云盘
  },
  methods: {
    /**
     * Description: 获取 country_id 和 offer_id
     * Author: yanlichen <yanlichen@tuozhongedu.com>
     */
    getCountryOfferId() {
      return new Promise((resolve) => {
        this.$http._get({
          url: '/index/apply_file/initDefined',
          data: {
            crm_id: this.$route.params.id
          }
        }).then((data) => {
          resolve(data);
        });
      });
    },
    /*
    * 选择 取消 控制 显示 || 隐藏
    * */
    setCycleChoose (isTrue) {
      if (isTrue) {
        this.fatherCloudSub.isCycleChoose = isTrue;
        this.fatherCloudSub.isCyCLeChooseMask = true;
      } else {
        this.fatherCloudSub.isCycleChoose = isTrue;
        this.fatherCloudSub.isCyCLeChooseMask = false;
      }
    },
    /*
     * 全选 checkbox
     * */
    handleCheckAllChange(val) {
      this.checkList = val ? allChecked : [];
      this.$refs.refAllCheckData.refAllCheckList(); // 坑爹做法 没办法
      this.isIndeterminate = false;
    },
    /*
    * 子组件返回数据
    * */
    componentCloudData(cb) {
      allChecked = [];
      cb.forEach((item) => {
        if (item.file_list.length > 0) {
          const key = `${item.yun_id}_${item.id}`;
          allChecked.push(key);
          this.allFiles[key] = {
            files: item.file_list,
            folder: item.file_name,
          };
        }
      });
    },
    /*
    * 子组件 单选后判断是否为全选
    * */
    checkListData(cb) {
      let checkedCount = cb.length;
      this.checkList = cb;
      this.checkAll = checkedCount === allChecked.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < allChecked.length;
    },
    /*
    * 执行子组件方法 清空子组件checkedMeterial
    * */
    closeCallback() {
      this.$refs.closeCloud.closeMeterial();
    },
    /*
    * 云盘批量下载
    * */
    downloadFile(allLoad) {
      let keyData = '';
      let valData = [];
      allLoad.filter((item) => {
        keyData = item.substring(0, item.indexOf('_'));
        valData.push(item.substring(item.lastIndexOf('_') + 1));
        return true;
      });
      this.$http._post({
        url: '/index/apply_file/downloadFile',
        data: {
          data_list: { [keyData]: valData },
          country_id: this.countryOfferId.country_id,
          crm_id: this.$route.params.id
        }
      }).then((response) => {
        window.location.href = response.data;
      });
    },
    getFileName(url, folder) {
      const parts = url.split('/');
      return decodeURIComponent(`${folder}/${parts[parts.length - 1]}`);
    },
    /**
     * 批量下载
     */
    batchDownload() {
      const msg = this.$message({
        message: '下载中...',
        duration: 0,
        showClose: false,
      });
      NProgress.start();
      const zip = new JSZip();
      const filePromises = [];
      const files = [];
      let currentProgress = 0;
      this.checkList.forEach((item) => {
        if (item in this.allFiles) {
          const file = this.allFiles[item];
          zip.folder(file.folder);
          file.files.forEach((fileItem) => {
            const fileUrl = new URL(Vue.filter('imgHome')(fileItem));
            files.push(this.getFileName(fileUrl.pathname, file.folder));
            filePromises.push(getBinaryContent(
              Vue.filter('imgHome')(fileUrl.pathname, true),
              {
                progress: (p) => {
                  if (p.percent === 100) {
                    currentProgress += 100;
                    NProgress.set(currentProgress / 100 / files.length);
                  }
                }
              }
            ));
          });
        }
      });
      Promise.all(filePromises).then((buffers) => {
        buffers.forEach((buffer, index) => {
          zip.file(files[index], buffer, { binary: true });
        });
        zip.generateAsync({ type: 'blob' }).then((blob) => {
          this.$http.saveFile(blob, `材料云盘_${this.$route.params.id}_${moment().format('YYYYMMDD')}`);
        });
        msg.close();
        this.$message.success('下载成功!');
      }).catch(() => {
        NProgress.done(true);
        msg.close();
        this.$message.error('下载失败!');
      });
    }
  },
  watch: {
  }
};
</script>
<style scoped>
  .hover-cloud{
    display: flex;
  }
  .hover-cloud:hover .hover-mask{
    width: 100%;
    display: flex;
  }
  .hover-cloud .hover-mask{
    position: relative;
    z-index: 0;
    width: 100%;
    display: none;
  }
  .hover-cloud:hover .hover-mask2{
    width: 100%;
    display: none;
  }
  .hover-cloud .hover-mask2{
    width: 100%;
    display: block;
  }
  .noCycle-operation{
    margin-left: 10px;
  }
  .noCycle-main{
    margin-top: 10px;
    border-top: #f6f6f6 solid 4px;
  }
  .noCycle-main > .cloud-group{
    display: flex;
    position: relative;
    width: 160px;
    height: 112px;
    margin: 10px;
    padding: 6px;
    float: left;
    border: #b8c4ce dashed 1px;
    cursor: pointer;
    font-size: 100%;
  }
  .cycle-cont{
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    text-align: center;
  }
  .cycle-mask{
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.3);
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
  }
  .cycle-mask .el-checkbox{
    width: 100%;
    height: 100%;
    margin: 4px;
  }
  .noCycle-block{
    margin-left: 10px;
    display: inline-block;
  }
  .noCycle-block .el-checkbox{
    margin-left: 10px;
  }
  .cycle-hover{
    display: flex;
    background: #f2f2f2;
    border: solid #e7e7e7 1px;
    align-items: center;
    flex-wrap:wrap;
  }
  .cycle-hover > div{
    width: 50%;
    text-align: center;
  }
  .cycle-yes-material{
    width: 160px;
    position: relative;
    padding-top: 58px;
    color: #fff;
    overflow: hidden;
  }
  .yes-material-bg{
    background: url("../../assets/images/stuffbg.jpg") no-repeat center;
  }
  .meterial-ico{
    position: absolute;
    right: 3px;
    top: 3px;
    font-size: 22px;
  }
  .yes-material-bg .meterial-ico{
    color: #fff;
  }
  .meterial-title{
    text-align: center;
    font-size: 14px;
  }
  .no-meterial-bg{
    background: url("../../assets/images/no-stuffbg.jpg") no-repeat center;
  }
  .no-meterial-bg .meterial-ico{
    color: #f7ba2a;
  }
  .cycle-confirmed{
    background: #3368fa;
    color: #fff;
  }
  .confirmed{
    position: absolute;
    right: 0px;
    top: 5px;
    padding: 2px 8px;
    background: #ffcd38;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    color: #424141;
    font-size: 12px;
  }
  .cycle-ico{
    background: url("../../../src/assets/images/cycle-ico.png") no-repeat;
    display: block;
    width: 45px;
    height:45px;
    margin: 10px auto;
  }
  .cycle-confirmed .cycle-ico{
    background: url("../../../src/assets/images/cycle-ico1.png") no-repeat;
  }
  /* 材料展示 走马灯*/
  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
  }
  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }
  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }
  .el-carousel__indicators--outside{
    display: none;
  }
  .fullscreen-v-img{
    z-index: 10001 !important;
  }
  .left-rotate{
    position: fixed;
    bottom:20px;
    left:45%;
    width: 50px;
    height:50px;
    z-index: 1003;
    cursor: pointer;
    background: #fff url(../../../src/assets/images/icon-rotate-l.png) no-repeat center;
    opacity:0.8;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    -ms-border-radius: 5px;
    border-radius: 5px;
    display: none;
  }
  .right-rotate{
    position: fixed;
    bottom:20px;
    left:49%;
    width: 50px;
    height:50px;
    z-index: 1003;
    cursor: pointer;
    background: #fff url(../../../src/assets/images/icon-rotate-r.png) no-repeat center;
    opacity:0.8;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    -ms-border-radius: 5px;
    border-radius: 5px;
    display: none;
  }
  .save-rotate{
    position: fixed;
    bottom:20px;
    left:53%;
    width: 50px;
    height:50px;
    line-height:50px;
    background: #fff;
    z-index: 1003;
    color:#333;
    text-align: center;
    cursor: pointer;
    opacity:0.8;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    -ms-border-radius: 5px;
    border-radius: 5px;
    font-size:15px;
    display: none;
  }
  .left-rotate:hover,.right-rotate:hover,.save-rotate:hover{
    opacity:1;
  }
  .save-rotate:after{
    content:"保存";
  }
  .content-v-img{
    text-align: center;
  }
  .content-v-img canvas {
    pointer-events: none;
  }

</style>
